<template>
    <button id="PLAY_PAUSE" name="PLAY_PAUSE" class="btn" data-vcode="PLAY">
        <img src="/images/icons/playPause.svg" alt="" role="img" aria-hidden="true" />
        <label>{{ $t('playPauseButton') }}</label>
    </button>
</template>
<script>
export default {};
</script>
